import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import styles from './Layout.module.css'

export function AppShell() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  return (
    <div className={`${styles.shell} ${sidebarCollapsed ? styles.collapsed : ''}`}>
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <div className={styles.main}>
        <Topbar />
        <div className={styles.content}>
          <Outlet />
        </div>
        <footer className={styles.appFooter}>
          <span>Powered by <a href="https://keder.io" className={styles.footerLink}>Keder</a></span>
          <span className={styles.footerDivider}>·</span>
          <a href="https://keder.io/security.html" className={styles.footerLink}>Security</a>
          <span className={styles.footerDivider}>·</span>
          <span className={styles.footerMuted}>&copy; {new Date().getFullYear()} Keder. All rights reserved.</span>
        </footer>
      </div>
    </div>
  )
}
